import React from 'react';
import { PlayIcon, StarIcon } from '@heroicons/react/24/outline';

const SuccessStories = ({ stats }) => {
  const testimonials = [
    {
      name: "Shankar",
      role: "Coffee Shop Owner, Guntur",
      image: "images/kplp.png",
      fallbackImage: "https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      quote: "I'm earning ₹8470 monthly from my coffee shop's TV screen. The setup was effortless, and the ads actually complement my business atmosphere. Best passive income decision I've made!",
      metric: "₹8470/month",
      metricLabel: "Average Earnings"
    },
    {
      name: "Kumar",
      role: "Marketing Director, MeechoiceAds.",
      image: "images/pplk.png",
      fallbackImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      quote: "We achieved 340% ROI in our first quarter using Sy9 Network. The targeting precision and real-time analytics helped us optimize campaigns like never before. Game-changing platform!",
      metric: "340% ROI",
      metricLabel: "First Quarter Results"
    }
  ];

  return (
    <section id="success-stories" className="py-20 section-separator">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Success Stories
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Real results from screen owners and advertisers using our platform
          </p>
        </div>

        {/* Video Testimonials */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-card overflow-hidden">
              <div className="relative">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-48 object-cover"
                  onError={(e) => {
                    e.target.src = testimonial.fallbackImage;
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <button className="bg-white/90 backdrop-blur-sm rounded-full p-4 hover:bg-white transition-colors">
                    <PlayIcon className="w-8 h-8 text-primary" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="flex text-accent">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} className="w-5 h-5 fill-current" />
                    ))}
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-text-primary mb-2">{testimonial.name}</h3>
                <p className="text-text-secondary text-sm mb-4">{testimonial.role}</p>
                <blockquote className="text-text-secondary italic mb-4">
                  "{testimonial.quote}"
                </blockquote>
                <div className="p-3 bg-primary/10 rounded-lg">
                  <div className="text-center">
                    <div className="text-xl font-bold text-primary">{testimonial.metric}</div>
                    <div className="text-sm text-text-secondary">{testimonial.metricLabel}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Network Statistics */}
        <div className="bg-white rounded-2xl shadow-card p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-text-primary mb-4">Platform Statistics</h3>
            <p className="text-text-secondary">Real-time metrics from our growing network</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                {stats.activeScreens.toLocaleString()}
              </div>
              <div className="text-text-secondary">Active Screens</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                {stats.cities}
              </div>
              <div className="text-text-secondary">Cities Covered</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                {stats.impressions}
              </div>
              <div className="text-text-secondary">Monthly Impressions</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                {stats.revenue}
              </div>
              <div className="text-text-secondary">Revenue Generated</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;